import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const PlayIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 18;
  const color = props.color || 'black';
  return <Icon name={'play'} size={size} color={color} />;
};

export default React.memo(PlayIcon);
